import { useEffect } from "react";
import { useLocation } from "wouter";
import Logo from "../assets/Logo";

function NotFound() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    document.title = "Not Found - Seismic Connect";
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen w-full bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 px-4">

        <div className="relative w-full max-w-3xl ">

        <svg
          className="absolute -top-16 -left-10 w-40 h-16 opacity-40 pointer-events-none hidden sm:block"
          viewBox="0 0 160 60"
          fill="none"
        >
          <path
            d="M0 30 L25 30 L35 10 L45 50 L55 30 L80 30 L90 15 L100 30 L160 30"
            stroke="#3B82F6"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <div className="bg-white rounded-2xl shadow-xl border border-slate-100 px-8 py-10 sm:px-16 sm:py-14 text-center">
          <div className="flex justify-center mb-6">
            <Logo size="large" />
          </div>

          <h1 className="text-7xl font-extrabold bg-gradient-to-r from-blue-800 via-blue-600 to-blue-500 bg-clip-text text-transparent leading-none">
            404
          </h1>

          <h2 className="mt-3 text-2xl font-bold text-slate-800">
            Page Not Found
          </h2>

          <p className="mt-3 text-slate-500 text-sm sm:text-base leading-relaxed">
            The page you're looking for doesn't exist or may have been moved.
            Let's get you back to somewhere useful.
          </p>

        {/* Return to dashboard button */}
          <button
            onClick={() => setLocation("/")}
            className="mt-8 w-full inline-flex items-center justify-center gap-2 rounded-lg
                       bg-gradient-to-r from-blue-800 to-blue-500 px-6 py-3
                       text-white font-semibold shadow-md
                       hover:from-blue-900 hover:to-blue-600
                       transition-all duration-200"
          >
            ← Return to Dashboard
          </button>
        </div>

        <p className="mt-6 text-center text-xs text-slate-400">
          © 2026 Seismic Connect. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default NotFound;